export default "__VITE_ASSET__C3cLc2kW__"